import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'utcToLocal',
})
export class UtcToLocalPipe implements PipeTransform {
  private defaultFormat: string = 'DD MMM YYYY hh:mm A';
  transform(value: any, format?: string): any {
    const dateFormat = format || this.defaultFormat;

    // Convert the UTC date to local timezone using moment-timezone
    const localDate = moment.utc(value).local().format(dateFormat);
    return localDate;
  }
}
